module.exports = __webpack_public_path__ + "img/edit-blue.a08baaad.svg";